module.exports = __webpack_public_path__ + "img/chaomeng_bg.a0f1a01b.jpg";